import { GraphQLError, GraphQLScalarType, Kind, type ValueNode, } from "graphql";
import { WEI, } from "@bracket/blocksmith";

export const WEIScalar = new GraphQLScalarType<WEI, string>({
	name: "WEI",
	description: "A high-precision numeric value for blockchain applications.",
	serialize: (value: WEI) => {
		try {
			const WEIStr = value.toString();
			const precision = value.asset ?? value.getPrecision();
			return JSON.stringify([WEIStr, precision]);
		}
		catch(error) {
			throw new GraphQLError(`Invalid WEI value: ${value}`, { extensions: { code: "BAD_USER_INPUT", originalError: error, }, });
		}
	},
	parseValue: (value: string) => {
		try {
			const [valueString, precision] = JSON.parse(value);
			return WEI.fromSync(valueString, precision);
		}
		catch(error) {
			throw new GraphQLError(`Invalid WEI value: ${value}`, { extensions: { code: "BAD_USER_INPUT", originalError: error, }, });
		}
	},
	parseLiteral: (ast) => {
		if(ast.kind === Kind.STRING) {
			try {
				const [ value, precision ] = JSON.parse(ast.value);
				return WEI.fromSync(value, precision);
			}
			catch(error) {
				throw new GraphQLError(`Invalid WEI value: ${ast.value}`, { extensions: { code: "BAD_USER_INPUT", originalError: error, }, });
			}
		}
		throw new GraphQLError(`Invalid WEI value: ${ast.value}`, { extensions: { code: "BAD_USER_INPUT", }, });
	},
});
